<template>
  <div class="sidebar-logo-container">
    <router-link
      v-if="!collapse"
      key="collapse"
      class="sidebar-logo-link"
      to="/"
    >
      <svg
        width="54"
        height="39"
        viewBox="0 0 54 42"
        fill="none"
        style="margin-top: 5px"
      >
        <path d="M8.06191 10.0218H0V18.6492H8.06191V10.0218Z" fill="#FF3495" />
        <path
          d="M18.2909 33.118V28.3927C18.2909 28.3828 18.2909 28.3729 18.2909 28.363V18.6492H26.3528V10.0218H18.2909V0.256531H10.1807V28.363C10.1807 35.7398 15.8225 41.7414 22.7572 41.7414H29.4054V33.118H18.2928H18.2909Z"
          fill="white"
        />
        <path
          d="M53.2134 33.116H31.5203V41.7434H53.2134V33.116Z"
          fill="white"
        />
        <path
          d="M53.8458 18.6472C53.8458 11.211 48.1594 5.16193 41.1689 5.16193C34.1784 5.16193 28.4919 11.211 28.4919 18.6472H36.6022C36.6022 15.968 38.6521 13.7874 41.1708 13.7874C43.6894 13.7874 45.7393 15.968 45.7393 18.6472C45.7393 21.3265 43.6894 23.5071 41.1708 23.5071H31.524V32.1345H37.9397L41.8478 32.1147C48.5239 31.7388 53.8477 25.844 53.8477 18.6492L53.8458 18.6472Z"
          fill="white"
        />
      </svg>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #000;
  text-align: center;
  overflow: hidden;
  min-width: calc(191px + 12px);

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 191px;
      height: 42px;
      vertical-align: middle;
      // margin-left: 6px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #000;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      vertical-align: middle;
    }
  }

  &.collapse {
    min-width: 42px;
    .sidebar-logo {
      width: 42px;
    }
  }
}
</style>
